import React, { useState, useEffect } from 'react';
import DesktopLayout from './DesktopLayout/DesktopLayout';
import MobileLayout from './MobileLayout/MobileLayout';

const PageLayout = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const checkScreenSize = () => {setIsMobile(window.innerWidth < 750);};

  useEffect(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);}, []);

  return (
    <div className="max-w-full">
    {isMobile ? (<MobileLayout>{children}</MobileLayout>) : (<DesktopLayout>{children}</DesktopLayout>)}
    </div>);};

export default PageLayout;
